import ReactCountryFlag from 'react-country-flag'
import { useTranslation } from 'react-i18next'

const LanguageToogle = () => {
  const { i18n } = useTranslation()
  const handleChange = (code: string) => {
    i18n.changeLanguage(code)
  }

  return (
    <div className="flex items-center space-x-2 p-2 rounded-lg bg-gray-100 dark:bg-gray-800">
      <button
        onClick={() => handleChange('fr')}
        className={`p-2 rounded-lg ${i18n.language === 'fr' ? 'bg-white dark:bg-gray-700 shadow-sm' : ''}`}
        title="Français"
      >
        <ReactCountryFlag
          countryCode="fr"
          svg
          style={{
            width: '1.5em',
            height: '1.5em',
          }}
        />
      </button>
      <button
        onClick={() => handleChange('en')}
        className={`p-2 rounded-lg ${i18n.language === 'en' ? 'bg-white dark:bg-gray-700 shadow-sm' : ''}`}
        title="English"
      >
        <ReactCountryFlag
          countryCode="gb"
          svg
          style={{
            width: '1.5em',
            height: '1.5em',
          }}
        />
      </button>
    </div>
  )
}

export default LanguageToogle
